module.exports = __webpack_public_path__ + "img/undraw_programming_2svr.4214f8c6.svg";